import React from "react";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { validateArray } from "../../utils/validate";

import {
  Chart as ChartJS,
} from "chart.js";

ChartJS.register(ChartDataLabels);

const SimpleChartPie = ({ data, cantidad, listY, title, onClick, generalData, setIt }) => {
  const combinedData = listY.map((item, index) => ({
    label: item.label,
    value: data[index],
  }));

  const sortedData = combinedData.sort((a, b) => b.value - a.value);

  const sortedLabels = sortedData.map((item) => item.label);
  const sortedValues = sortedData.map((item) => item.value);

  const fixedColors = [
  "#00B000",
  "#FF3333",
  "#3377FF",
  "#FF9933",
  "#993399",
  "#FF99CC",
  "#33CCCC",
  "#FFFF66",
  "#339999",
  "#993333",
  "#999933",
  "#FF33FF",
  "#CC6666",
  "#66FF66",
  "#6666CC",
  "#FFCC66",
  "#99FF66",
  "#666699",
  "#FF66AA",
  "#33BBBB",
  "#BBFF66",
  "#FF6666",
  "#996633",
  "#FF9966",
  "#339966",
];

  // Si hay más de 3 → repetir patrón
  const backgroundColors = sortedLabels.map((_, index) =>
    fixedColors[index % fixedColors.length]
  );

  const footer = (tooltipItems) => {
    return validateArray(cantidad)
      ? `Cantidad T.: ${cantidad[tooltipItems[0].dataIndex]}`
      : null;
  };

  return (
    <Pie
      style={{ maxHeight: "650px", overflowX: "auto" }}
      options={{
        plugins: {
          title: {
            display: false,
            text: title,
          },
          datalabels: {
            color: "#fff",
            formatter: (value, context) => {
              const total = sortedValues.reduce((acc, val) => acc + val, 0);
              const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
              return `${percentage}%`;
            },
            font: {
              size: 20,
            },
            anchor: "center",
            align: "center",
            backgroundColor: backgroundColors, // ← colores fijos
          },
          tooltip: {
            callbacks: {
              footer: footer,
            },
          },
          legend: {
            display: false,
            position: "top",
          },
        },
        responsive: true,
        onClick: (_, element) => {
          if (element.length) {
            const index = element[0].index;
            setIt(generalData?.dataCols[index]);

            if (generalData.onClick) {
              generalData.onClick({
                year: generalData.year,
                fieldname: generalData.fieldname,
                info: generalData?.dataCols[index],
                numMonth: generalData.numMonth,
              });
            }
            if (validateArray(element)) {
              onClick(sortedLabels[index], null);
            }
          }
        },
      }}
      data={{
        labels: sortedLabels,
        datasets: [
          {
            label: title,
            data: sortedValues,
            backgroundColor: backgroundColors, // ← colores fijos
          },
        ],
      }}
    />
  );
};

export default SimpleChartPie;
